import { queryOptions, useQuery } from '@tanstack/react-query'
import { get } from 'lodash/fp'

import { skills } from '@/http/api/skills'

import { skillsKeys } from './queryKeys'

const NO_CURRENT_SKILL_SET_MESSAGE = 'skills.error.current-skill-not-set'

export function isNoCurrentSkillSetError(error: unknown): boolean {
  return get('response.data.message', error) === NO_CURRENT_SKILL_SET_MESSAGE
}

export const skillsCurrentOptions = () =>
  queryOptions({
    queryKey: skillsKeys.current(),
    queryFn: () => skills.current(),
    retry: (failureCount, error) => {
      if (isNoCurrentSkillSetError(error)) {
        return false
      }
      return failureCount < 2
    },
  })

interface Props {
  enabled?: boolean
}

export function useSkillsCurrent({ enabled = true }: Props = {}) {
  return useQuery({ ...skillsCurrentOptions(), enabled })
}
